import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import "./LoginView.css";
import { NavLink, Navigate } from "react-router-dom";
import { SLinkContext } from "../state/context";
import LoginError from "../components/login/LoginError";
import { loginAction } from "../state/actions";
import { ApiStatus, callApi } from "../api/ApiUtilities";
import { User } from "../data/User";
import LoginMessage from "../components/login/LoginMessage";

function LoginView() {
  const { state, dispatch } = useContext(SLinkContext);
  const [submiting, setSubmiting] = useState(false);
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [videoLink, setVideoLink] = useState("");
  let params = new URLSearchParams(window.location.search);
  let queryStringMsg = params.get("message") ?? "";

  useEffect(() => {
    callApi<string>("/api/auth/videolink", "GET").then((response) => {
      if (response.data) {
        setVideoLink(response.data);
      }
    });
  }, []);

  async function onSubmit(event: SyntheticEvent) {
    setSubmiting(true);
    event.preventDefault();
    setError("");

    var response = await callApi<User>("/api/auth", "POST", { username: username, password: password });
    if (response.status === ApiStatus.Ok) {
      dispatch(loginAction(response.data as User));
    } else {
      setSubmiting(false);
      setError(response.message);
    }
  }

  if (state.user) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="sl-auth">
      <div className="d-flex">
        <img className="mx-auto" src="/imgs/ADoM-logo-216-colour.png" width="132" height="75" alt="Anglican Diocese of Melbourne" />
      </div>
      <h1 className="sl-auth-title">Welcome to Synod Link</h1>
      <p className="sl-auth-subtitle">The online meeting portal of the Anglican Diocese of Melbourne</p>

      <LoginMessage message={queryStringMsg} />

      <main className="sl-auth-card">
        <form onSubmit={onSubmit}>
          <div className="form-floating mb-2">
            <input
              type="email"
              className="form-control"
              id="loginEmail"
              placeholder="name@example.com"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <label htmlFor="loginEmail">Email address</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="password"
              className="form-control"
              id="loginPassword"
              placeholder="Password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label htmlFor="loginPassword">Password</label>
          </div>

          <button disabled={submiting} className="w-100 btn btn-lg btn-primary" type="submit">
            {submiting ? "Signing in..." : "Sign in"}
          </button>

          <LoginError error={error} />

          <p className="mt-3 mb-0 text-center">
            <NavLink to="/login/forgot">Forgot password</NavLink>
          </p>
        </form>
      </main>

      <div className="card mt-4">
        <div className="card-header">Watching the livestream</div>
        <div className="card-body">
          {videoLink ? (
            <p className="mb-0">
              Lay and Clergy Representatives registered to attend online for medical/disability reasons must sign in above to participate in the meeting. All other interested parties can{" "}
              <a href={videoLink}>watch the livestream here</a>.
            </p>
          ) : (
            <p className="mb-0">During a meeting of Synod a link to the livestream will be available here for visitors and other interested parties.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginView;
